import { TITLES } from 'constants/pagesTitles';
import PageContainerImgBg from 'components/layout/PageContainer/PageContainerImgBg';
import VerifyEmailPage from 'core/views/VerifyEmailPage';

export const VerifyEmail = () => (
  <PageContainerImgBg
    imageBg="/images/section-bckg.jpg"
    titles={TITLES.confirmPage}
    isLogoHidden
    isSignInPage
  >
    <VerifyEmailPage />
  </PageContainerImgBg>
);

export default VerifyEmail;
